export const THEME_STORAGE_KEY = "admin-shop-theme" as const;

export const themeOptions = [
  {
    id: "theme-corporate",
    label: "اداری",
    icon: "🏢",
    description: "پالت رسمی و روشن پیش‌فرض پنل",
  },
  {
    id: "dark",
    label: "تاریک",
    icon: "🌙",
    description: "مناسب برای محیط‌های کم‌نور",
  },
  {
    id: "theme-emerald",
    label: "زمردی",
    icon: "💚",
    description: "ترکیب سبز‌های ملایم برای داشبورد",
  },
  {
    id: "theme-rose",
    label: "رز",
    icon: "🌸",
    description: "رنگ‌بندی صورتی و بنفش نرم",
  },
  {
    id: "theme-ocean",
    label: "اقیانوسی",
    icon: "🌊",
    description: "آبی‌های خنک و متعادل",
  },
] as const;

export type ThemeId = (typeof themeOptions)[number]["id"];

export const themeIds: ThemeId[] = themeOptions.map((option) => option.id);

export const defaultThemeId: ThemeId = "theme-corporate";
